import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({providedIn: 'root'})
export abstract class CityGateway {
    abstract getAll(): Observable<any[]>
    abstract getByCountry(countryId: number): Observable<any[]>
}
